/*
 * @Author       : 程哲林
 * @Date         : 2022-07-26 21:44:08
 * @LastEditors  : 程哲林
 * @LastEditTime : 2022-07-26 21:44:33
 * @FilePath     : /marketing-introduce-ssr/utils/bus.ts
 * @Description  : 未添加文件描述
 */
import EventEmitter from 'eventemitter3'
const bus = new EventEmitter()
export default bus
